<template>
  <div>
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" :destroy-on-close="true"
      :before-close="cancel">
      <el-form label-width="110px" ref="form" :model="form" :rules="rules">
        <el-form-item label="单位名称" prop="companyName">
          <el-input size="small" v-model="form.companyName" auto-complete="off" placeholder="请输入单位名称"></el-input>
        </el-form-item>
        <el-form-item label="单位类型" prop="companyType">
          <el-select v-model="form.companyType" placeholder="请选择单位类型">
            <el-option v-for="item in companyTypeOptions" :key="item.label" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位地址" prop="companyAddress" label-width="100px">
          <w-address ref="address" :address="form.companyAddress"></w-address>
        </el-form-item>
        <el-form-item label="纳税登记编号" prop="taxRegistrationNumber">
          <el-input size="small" v-model="form.taxRegistrationNumber" auto-complete="off"
            placeholder="请输入纳税登记编号"></el-input>
        </el-form-item>
        <el-form-item label="开户行&帐号" prop="bankAccountNumber">
          <el-input type="textarea" :autosize="{ minRows: 3 }" size="small" v-model="form.bankAccountNumber"
            auto-complete="off" placeholder="请输入开户行&帐号">
          </el-input>
        </el-form-item>
        <el-form-item label="开票地址&电话" prop="billingAddressPhone">
          <el-input type="textarea" :autosize="{ minRows: 3 }" size="medium" v-model="form.billingAddressPhone"
            auto-complete="off" placeholder="请输入开票地址&电话">
          </el-input>
        </el-form-item>
        <el-form-item label="邮编" prop="postalCode">
          <el-input size="small" v-model="form.postalCode" auto-complete="off" placeholder="请输入邮编号码">
          </el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :autosize="{ minRows: 3 }" maxlength="300" show-word-limit
            placeholder="请输入备注">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
      </div>
    </el-dialog>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import {addCompany, editCompany} from "@/api/dilivery/customer/company";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "AddCustomerDialog",
  props:['showDialog','selectType','selectDetail'],
  components: { Loading },
  data(){
    return{
      loading:false,
      provinces: '',
      citys: '',
      districts: '',
      address: '',
      companyTypeOptions: [
        // {label: '渠道客户'},
        // {label: '终端客户'},
        {label: '科研院所'},
        {label: '高校'},
        {label: '企业'},
        {label: '医院'},
        {label: '个人'},
        {label: '其它'}
      ],
      title:'',
      form:{
        companyCode: '',
        companyName: '',
        companyType: '',
        taxRegistrationNumber: '',
        parentCompanyName: '',
        legalPerson: '',
        companyAddress: '',
        postalCode: '',
        companyWebsite: '',
        bankAccountNumber: '',
        billingAddressPhone: '',
        remark: ''
      },
      rules: {
        companyCode: [
          {message: '请输入单位编号', trigger: 'change'}
        ],
        companyName: [
          {required: true, message: '请输入单位名称', trigger: 'change'}
        ],
        companyType: [
          {required: true, message: '单位类型不能为空', trigger: 'change'}
        ],
        taxRegistrationNumber: [
          {required: true, message: '请输入纳税登记编号', trigger: 'change'}
        ],
        parentCompanyName: [
          { message: '请输入母公司名称', trigger: 'change'}
        ],
        companyAddress: [
          { message: '请输入单位地址', trigger: 'change'}
        ],
        legalPerson: [
          {message: '请输入法人名称', trigger: 'change'}
        ],
        postalCode: [
          {message: '请输入邮政编号', trigger: 'change'}
        ],
        companyWebsite: [
          {message: '请输入网址', trigger: 'change'}
        ],
        bankAccountNumber: [
          {message: '请输入开户行&帐号', trigger: 'change'}
        ],
        billingAddressPhone: [
          {message: '请输入开票地址&电话', trigger: 'change'}
        ],
        remark: [
          {message: '请输入备注', trigger: 'change'}
        ],
      },
    }
  },
  watch: {
    selectType : {
      handler(newVal) {
        if (newVal) {
          if (newVal.type === 'edit') {
            this.title = '编辑客户单位信息'
          } else {
            this.title = '添加客户单位信息'
          }
        }
      },
      immediate: true
    },
    selectDetail : {
      handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          this.form.id = newVal.id;
          this.form.companyAddress = newVal.companyAddress;
          this.form.companyCode = newVal.companyCode;
          this.form.companyName = newVal.companyName;
          this.form.companyType = newVal.companyType;
          this.form.taxRegistrationNumber = newVal.taxRegistrationNumber;
          this.form.parentCompanyName = newVal.parentCompanyName;
          this.form.legalPerson = newVal.legalPerson;
          this.form.postalCode = newVal.postalCode;
          this.form.companyWebsite = newVal.companyWebsite;
          this.form.bankAccountNumber = newVal.bankAccountNumber;
          this.form.billingAddressPhone = newVal.billingAddressPhone;
          this.form.remark = newVal.remark;
        }
      },
      immediate: true
    },
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      if(this.$refs.address.getData().province){
        this.form.companyAddress = this.$refs.address.getData().province
      }
      if(this.$refs.address.getData().city){
        this.form.companyAddress = this.form.companyAddress + this.$refs.address.getData().city
      }
      if(this.$refs.address.getData().district){
        this.form.companyAddress = this.form.companyAddress + this.$refs.address.getData().district
      }
      if(this.$refs.address.getData().detail){
        this.form.companyAddress = this.form.companyAddress + this.$refs.address.getData().detail
      }
      this.$refs.form.validate(valid=>{
        if(valid){
          this.loading = true
          // 请求方法
          if (this.selectType.type === 'add') {
            addCompany(this.form).then(res => {
              if (res.code === 200) {
                this.loading = false
                this.$emit('submit','confirm')
                this.$messageUi.success('添加成功')
              }
            }).catch(err => {
              this.loading = false
            })
          } else {
            editCompany(this.form).then(res => {
              if (res.code === 200) {
                this.loading = false
                this.$emit('submit','confirm')
                this.$messageUi.success('修改成功')
              }
            }).catch(err => {
              this.loading = false
            })
          }
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })

    }
  },

}
</script>

<style scoped>
</style>
